import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';

import { ITimelineItem } from '@clients/timelineClient';
import TransactionOneLiner from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TransactionOneliner';
import TimelineItemIconFactory from '@components/accountTimeline/accountTimelineBlock/TimelineItemIconFactory';
import TimelineItemTemplate from '@components/accountTimeline/accountTimelineBlock/TimelineItemTemplate';
import { useAccount } from '@contexts/AccountProvider';
import accountTimelineType from '@messages/accountTimelineType';
import getEnumTranslation from '@utils/getEnumTranslation';

export type TimelineItemCashinProps = {
    timelineItem: ITimelineItem;
    highlightOnHover?: boolean;
    panelMode?: boolean;
    showTooltip?: boolean;
};

const TimelineItemCashin = ({
    timelineItem,
    highlightOnHover = false,
    panelMode = false,
    showTooltip = false,
}: TimelineItemCashinProps) => {
    const { program } = useAccount();

    const currencyCode = program?.currency_numeric_code;

    const title = getEnumTranslation('CASHIN', {
        messages: accountTimelineType,
    });

    const url = `/${timelineItem?.account_id}/timeline/${btoa(
        timelineItem?.timestamp,
    )}`;

    const urlForNextCursor = timelineItem?.next_cursor
        ? `/nextCursor/${timelineItem?.next_cursor}`
        : ``;

    return (
        <TimelineItemTemplate
            key={timelineItem.timestamp}
            testId="timelineitem-cashin"
            primaryTitle={title}
            avatar={
                <TimelineItemIconFactory
                    type={timelineItem.type}
                    category={timelineItem.category}
                />
            }
            primarySubtitle={
                <TransactionOneLiner
                    key={timelineItem.timestamp}
                    timestamp={timelineItem.timestamp}
                    category={timelineItem.category}
                    type={timelineItem.type}
                    showTooltip={showTooltip}
                />
            }
            secondaryTitle={
                <CurrencyFormatter
                    amount={timelineItem?.data?.item?.local_amount}
                    currency={currencyCode}
                    variant="success"
                    symbol="positive"
                />
            }
            secondarySubtitle={getEnumTranslation('credit')}
            urlToNavigateTo={url + urlForNextCursor}
            highlightOnHover={highlightOnHover}
            panelMode={panelMode}
        />
    );
};

export default TimelineItemCashin;
